import React, { useState } from 'react';
import { Card } from '../Shared/Card';
import { UserIcon, BuildingIcon, FileTextIcon, PlusIcon, EditIcon } from 'lucide-react';
export function CounterpartyProfiles() {
  const [activeCounterparty, setActiveCounterparty] = useState('acra');
  const counterparties = [{
    id: 'acra',
    name: 'Acra',
    type: 'Buyer',
    logo: 'https://via.placeholder.com/40',
    templates: ['DBRS', 'Kroll'],
    guidelines: {
      fico: 'Min 680',
      ltv: 'Max 75%',
      dscr: 'Min 1.15',
      experience: '3+ completed projects',
      exceptions: 'FICO < 680 allowed if LTV < 65%'
    }
  }, {
    id: 'lima-one',
    name: 'Lima One',
    type: 'Buyer',
    logo: 'https://via.placeholder.com/40',
    templates: ['DBRS'],
    guidelines: {
      fico: 'Min 700',
      ltv: 'Max 70%',
      dscr: 'Min 1.20',
      experience: '5+ completed projects',
      exceptions: 'None'
    }
  }, {
    id: 'dbrs',
    name: 'DBRS',
    type: 'Rating Agency',
    logo: 'https://via.placeholder.com/40',
    templates: ['Surveillance', 'Revolver', 'Performance'],
    guidelines: {
      fico: 'Min 660',
      ltv: 'Max 80%',
      dscr: 'Min 1.10',
      experience: 'Documented history',
      exceptions: 'Case by case review'
    }
  }];
  const activeProfile = counterparties.find(cp => cp.id === activeCounterparty);
  return <div className="space-y-6" data-id="element-219">
      <div className="flex justify-between items-center" data-id="element-220">
        <h2 className="text-xl font-semibold text-gray-800" data-id="element-221">
          Capital Buyer & Rating Agency Profiles
        </h2>
        <button className="px-4 py-2 bg-success rounded-full text-foreground/70 hover:bg-success/80 flex items-center text-sm transition-colors" data-id="element-222">
          <PlusIcon className="w-4 h-4 mr-2" data-id="element-223" />
          Add New Counterparty
        </button>
      </div>
      <div className="grid grid-cols-4 gap-6" data-id="element-224">
        <div className="col-span-1 space-y-4" data-id="element-225">
          {counterparties.map(counterparty => <div key={counterparty.id} className={`p-4 rounded-lg border cursor-pointer ${activeCounterparty === counterparty.id ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:bg-gray-50'}`} onClick={() => setActiveCounterparty(counterparty.id)} data-id="element-226">
              <div className="flex items-center" data-id="element-227">
                <div className="w-10 h-10 bg-gray-200 rounded-md flex items-center justify-center mr-3" data-id="element-228">
                  {counterparty.type === 'Buyer' ? <BuildingIcon className="w-6 h-6 text-gray-500" data-id="element-229" /> : <FileTextIcon className="w-6 h-6 text-gray-500" data-id="element-230" />}
                </div>
                <div data-id="element-231">
                  <h3 className="font-medium text-gray-900" data-id="element-232">
                    {counterparty.name}
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-233">{counterparty.type}</p>
                </div>
              </div>
            </div>)}
        </div>
        {activeProfile && <Card className="col-span-3" data-id="element-234">
            <div className="flex justify-between items-start mb-6" data-id="element-235">
              <div className="flex items-center" data-id="element-236">
                <div className="w-12 h-12 bg-gray-200 rounded-md flex items-center justify-center mr-4" data-id="element-237">
                  {activeProfile.type === 'Buyer' ? <BuildingIcon className="w-7 h-7 text-gray-500" data-id="element-238" /> : <FileTextIcon className="w-7 h-7 text-gray-500" data-id="element-239" />}
                </div>
                <div data-id="element-240">
                  <h3 className="text-xl font-medium text-gray-900" data-id="element-241">
                    {activeProfile.name}
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-242">{activeProfile.type}</p>
                </div>
              </div>
              <button className="px-3 py-1.5 bg-background border border-border rounded-full text-foreground/70 hover:bg-muted flex items-center text-sm transition-colors" data-id="element-243">
                <EditIcon className="w-4 h-4 mr-1" data-id="element-244" />
                Edit Profile
              </button>
            </div>
            <div className="grid grid-cols-2 gap-6" data-id="element-245">
              <div data-id="element-246">
                <h4 className="text-md font-medium text-gray-800 mb-4" data-id="element-247">
                  Required Templates
                </h4>
                <div className="space-y-3" data-id="element-248">
                  {activeProfile.templates.map((template, index) => <div key={index} className="flex items-center p-3 border border-gray-200 rounded-lg" data-id="element-249">
                      <FileTextIcon className="w-5 h-5 text-blue-500 mr-3" data-id="element-250" />
                      <span className="text-sm text-gray-800" data-id="element-251">{template}</span>
                    </div>)}
                </div>
              </div>
              <div data-id="element-252">
                <h4 className="text-md font-medium text-gray-800 mb-4" data-id="element-253">
                  Eligibility Guidelines
                </h4>
                <div className="space-y-3" data-id="element-254">
                  <div className="flex justify-between p-3 border border-gray-200 rounded-lg" data-id="element-255">
                    <span className="text-sm font-medium text-gray-700" data-id="element-256">
                      FICO
                    </span>
                    <span className="text-sm text-gray-800" data-id="element-257">
                      {activeProfile.guidelines.fico}
                    </span>
                  </div>
                  <div className="flex justify-between p-3 border border-gray-200 rounded-lg" data-id="element-258">
                    <span className="text-sm font-medium text-gray-700" data-id="element-259">
                      LTV
                    </span>
                    <span className="text-sm text-gray-800" data-id="element-260">
                      {activeProfile.guidelines.ltv}
                    </span>
                  </div>
                  <div className="flex justify-between p-3 border border-gray-200 rounded-lg" data-id="element-261">
                    <span className="text-sm font-medium text-gray-700" data-id="element-262">
                      DSCR
                    </span>
                    <span className="text-sm text-gray-800" data-id="element-263">
                      {activeProfile.guidelines.dscr}
                    </span>
                  </div>
                  <div className="flex justify-between p-3 border border-gray-200 rounded-lg" data-id="element-264">
                    <span className="text-sm font-medium text-gray-700" data-id="element-265">
                      Experience
                    </span>
                    <span className="text-sm text-gray-800" data-id="element-266">
                      {activeProfile.guidelines.experience}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-267">
              <h4 className="text-md font-medium text-gray-800 mb-4" data-id="element-268">
                Exceptions Allowed
              </h4>
              <div className="p-4 bg-gray-50 rounded-lg" data-id="element-269">
                <p className="text-sm text-gray-800" data-id="element-270">
                  {activeProfile.guidelines.exceptions}
                </p>
              </div>
            </div>
            <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-271">
              <h4 className="text-md font-medium text-gray-800 mb-4" data-id="element-272">
                Contact Information
              </h4>
              <div className="grid grid-cols-2 gap-6" data-id="element-273">
                <div className="space-y-4" data-id="element-274">
                  <div data-id="element-275">
                    <h5 className="text-sm font-medium text-gray-700 mb-2" data-id="element-276">
                      Primary Contact
                    </h5>
                    <div className="flex items-start" data-id="element-277">
                      <UserIcon className="w-5 h-5 text-gray-400 mt-0.5 mr-3" data-id="element-278" />
                      <div data-id="element-279">
                        <p className="text-sm font-medium text-gray-800" data-id="element-280">
                          John Smith
                        </p>
                        <p className="text-sm text-gray-500" data-id="element-281">
                          Capital Markets Director
                        </p>
                        <p className="text-sm text-gray-500" data-id="element-282">
                          john.smith@example.com
                        </p>
                        <p className="text-sm text-gray-500" data-id="element-283">(555) 123-4567</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="space-y-4" data-id="element-284">
                  <div data-id="element-285">
                    <h5 className="text-sm font-medium text-gray-700 mb-2" data-id="element-286">
                      Submission Instructions
                    </h5>
                    <p className="text-sm text-gray-800" data-id="element-287">
                      Send all DBRS templates to reporting@example.com by the
                      15th of each month. Include pool name and reporting period
                      in the subject line.
                    </p>
                  </div>
                  <div data-id="element-288">
                    <h5 className="text-sm font-medium text-gray-700 mb-2" data-id="element-289">
                      Notes
                    </h5>
                    <p className="text-sm text-gray-800" data-id="element-290">
                      Prefers clean exception logs. All exceptions must be
                      approved in writing before submission.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Card>}
      </div>
    </div>;
}